/*
 * @Author: Dong
 * @Date: 2022-04-20 16:03:06
 * @LastEditors: Dong
 * @LastEditTime: 2022-04-20 16:04:37
 */
import { useEffect, useRef } from 'react';

const usePrevious = (value: any) => {
  const ref = useRef<any>();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export default usePrevious;
